import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ot-schedule-upload-details',
  templateUrl: './ot-schedule-upload-details.component.html',
  styleUrls: ['./ot-schedule-upload-details.component.sass']
})
export class OtScheduleUploadDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
